export default {
  'setting.name': 'Setting',
};
